// src/components/home/CategoryBar.js
// Barre des catégories avec espacement pro - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import ROUTES from '../../constants/routes';

const CategoryBar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { theme } = useTheme();

  const categories = [
    { icon: '🏨', label: 'categories.sejours', path: ROUTES.SEJOURS },
    { icon: '🏠', label: 'categories.locations', path: ROUTES.LOCATIONS },
    { icon: '🌍', label: 'categories.immobilier', path: ROUTES.IMMOBILIER },
    { icon: '🛎️', label: 'categories.services', path: ROUTES.SERVICES },
  ];

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '16px',
      backgroundColor: theme.bg,
      borderBottom: `1px solid ${theme.borderSoft}`,
      gap: '8px',
    },
    button: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      flex: 1,
      padding: '12px 8px',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 200ms ease-in-out',
    },
    icon: {
      fontSize: '24px',
    },
    label: {
      fontSize: '12px',
      fontWeight: '600',
      color: theme.textSecondary,
      textAlign: 'center',
      lineHeight: '1.2',
    },
    labelActive: {
      color: theme.gold,
    },
  };

  return (
    <div style={styles.container}>
      {categories.map((cat) => (
        <button
          key={cat.path}
          style={styles.button}
          onClick={() => navigate(cat.path)}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <span style={styles.icon}>{cat.icon}</span>
          <span style={styles.label}>{t(cat.label)}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryBar;